document.addEventListener("DOMContentLoaded", function () {

  const fileInput =
    document.getElementById("customer_file");

  if (!fileInput) return;

  const addToCartForm =
    fileInput.closest("form");

  if (!addToCartForm) return;

  const hiddenInput =
    document.getElementById(
      "uploaded_file_url"
    );

  const submitButton =
    addToCartForm.querySelector(
      '[type="submit"]'
    );

  // -----------------------------------
  // SUPABASE CONFIG
  // -----------------------------------

  const SUPABASE_URL =
    "https://filkedjrhmmowmwmkxbd.supabase.co";

  const SUPABASE_ANON_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZpbGtlZGpyaG1tb3dtd21reGJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg0MDczMDUsImV4cCI6MjA5Mzk4MzMwNX0.6sx1eCX-LYd5h126VMByKdbRbKP4XSckJ7-l8z-FhGE";

  const BUCKET =
    "usautosupplies-bucket";

  // -----------------------------------
  // VALID FILE TYPES
  // -----------------------------------

  const allowedExtensions = [
    "pdf",
    "doc",
    "docx",
    "jpg",
    "jpeg",
    "png"
  ];

  // -----------------------------------
  // MAX FILE SIZE (10 MB)
  // -----------------------------------

  const maxFileSize =
    10 * 1024 * 1024;

  // -----------------------------------
  // FORM SUBMIT
  // -----------------------------------

  addToCartForm.addEventListener(
    "submit",
    async function (e) {

      const file =
        fileInput.files[0];

      // No file selected
      // allow normal add to cart

      if (!file) {
        return;
      }

      e.preventDefault();

      // -----------------------------------
      // VALIDATE FILE TYPE
      // -----------------------------------

      const extension =
        file.name
          .split(".")
          .pop()
          .toLowerCase();

      if (
        !allowedExtensions.includes(
          extension
        )
      ) {

        alert(
          "Allowed file types: PDF, DOC, DOCX, JPG, JPEG, PNG"
        );

        return;
      }

      // -----------------------------------
      // VALIDATE FILE SIZE
      // -----------------------------------

      if (
        file.size >
        maxFileSize
      ) {

        alert(
          "Maximum upload size is 10MB."
        );

        return;
      }

      // -----------------------------------
      // BUTTON STATE
      // -----------------------------------

      const originalButtonText =
        submitButton.innerText;

      submitButton.disabled =
        true;

      submitButton.innerText =
        "Uploading file...";

      try {

        // -----------------------------------
        // UNIQUE FILE NAME
        // -----------------------------------

        const timestamp =
          Date.now();

        const cleanFileName =
          file.name.replace(
            /\s+/g,
            "-"
          );

        const uniqueName =
          `${timestamp}-${cleanFileName}`;

        // -----------------------------------
        // UPLOAD TO SUPABASE
        // -----------------------------------

        const uploadUrl =
          `${SUPABASE_URL}/storage/v1/object/${BUCKET}/${uniqueName}`;

        const response =
          await fetch(
            uploadUrl,
            {
              method: "POST",

              headers: {

                apikey:
                  SUPABASE_ANON_KEY,

                Authorization:
                  `Bearer ${SUPABASE_ANON_KEY}`,

                "Content-Type":
                  file.type,

                "x-upsert":
                  "false"
              },

              body: file
            }
          );

        const result =
          await response.json();

        // -----------------------------------
        // SUCCESS
        // -----------------------------------

        if (
          response.ok
        ) {

          const publicFileUrl =
            `${SUPABASE_URL}/storage/v1/object/public/${BUCKET}/${uniqueName}`;

          hiddenInput.value =
            publicFileUrl;

          console.log(
            "File uploaded:",
            publicFileUrl
          );

          addToCartForm.submit();

        } else {

          console.error(
            "Upload failed:",
            result
          );

          alert(
            "File upload failed."
          );

          submitButton.disabled =
            false;

          submitButton.innerText =
            originalButtonText;
        }

      } catch (error) {

        console.error(
          "Upload error:",
          error
        );

        alert(
          "Something went wrong during file upload."
        );

        submitButton.disabled =
          false;

        submitButton.innerText =
          originalButtonText;
      }

    }
  );

});